import { useInfiniteQuery } from "react-query";
import { api } from "utils/api";
import type { ReviewRequest, ReviewResponse } from "../types";
import { reviewKeys } from "./queryKeys";

const getReviews = ({
  entityType,
  entityId,
  perPage = 10,
  sortBy,
  searchAfter,
}: ReviewRequest) => {
  if (!entityId || !entityType) {
    return Promise.reject(new Error("Invalid entity"));
  }

  const perPageQuery = `perPage=${perPage}`;
  const sortQuery = sortBy ? `sort=${sortBy}` : null;
  const searchAfterQuery = searchAfter ? `searchAfter=${searchAfter}` : null;
  const queries = [perPageQuery, sortQuery, searchAfterQuery]
    .filter(Boolean)
    .join("&");

  return api.get<ReviewResponse>(
    `/${entityType.toLowerCase()}s/${entityId}/reviews?${queries}`
  );
};

const useReviews = (params: Omit<ReviewRequest, "searchAfter">) =>
  useInfiniteQuery(
    reviewKeys.infinite(params),
    ({ pageParam }) => getReviews({ ...params, searchAfter: pageParam }),
    {
      enabled: !!params.entityId && !!params.entityType,
      getNextPageParam: (lastPage: ReviewResponse) => lastPage.searchAfter,
    }
  );

export { useReviews };
